import React from 'react';
import PropTypes from 'prop-types';
import lodashCompact from 'lodash/compact';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import { formatPhoneNumber } from 'common/formatters';

const SrSunSetupOwnerContact = ({ listing }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const _hasPropertySecondOwner = () => {
    return (
      lodashCompact([
        listing.propertySecondOwnerName,
        listing.propertySecondOwnerPhone,
        listing.propertySecondOwnerEmail,
      ]).length > 0
    );
  };

  const hasPropertySecondOwner = _hasPropertySecondOwner();

  return (
    <SrBox
      backgroundColor="white"
      borderRadius={isSmallScreen ? '14px' : '24px'}
      boxShadow="0px 5px 21px rgba(25, 51, 64, 0.05)"
      padding="20px"
    >
      <SrBox>
        <SrText
          font="greycliff"
          weight="800"
          fontSize="16px"
          lineHeight="25px"
          color="blueGreycliff"
          display="block"
        >
          {listing.propertyOwnerName}
        </SrText>
        <SrText
          font="greycliff"
          weight="600"
          fontSize="16px"
          lineHeight="25px"
          color="grey"
          display="block"
        >
          {formatPhoneNumber(listing.propertyOwnerPhone)}
        </SrText>
        <SrText
          font="greycliff"
          weight="600"
          fontSize="16px"
          lineHeight="25px"
          color="grey"
          display="block"
        >
          {listing.propertyOwnerEmail}
        </SrText>
      </SrBox>
      {hasPropertySecondOwner && (
        <SrBox marginTop="16px">
          <SrText
            font="greycliff"
            weight="800"
            fontSize="16px"
            lineHeight="25px"
            color="blueGreycliff"
            display="block"
          >
            {listing.propertySecondOwnerName || 'Second Property Owner'}
          </SrText>
          <SrText
            font="greycliff"
            weight="600"
            fontSize="16px"
            lineHeight="25px"
            color="grey"
            display="block"
          >
            {listing.propertySecondOwnerPhone
              ? formatPhoneNumber(listing.propertySecondOwnerPhone)
              : 'No phone number provided'}
          </SrText>
          <SrText
            font="greycliff"
            weight="600"
            fontSize="16px"
            lineHeight="25px"
            color="grey"
            display="block"
          >
            {listing.propertySecondOwnerEmail
              ? listing.propertySecondOwnerEmail.toLowerCase()
              : 'No email provided'}
          </SrText>
        </SrBox>
      )}
    </SrBox>
  );
};

SrSunSetupOwnerContact.propTypes = {
  listing: PropTypes.object.isRequired,
};

SrSunSetupOwnerContact.displayName = 'SrSunSetupOwnerContact';

export default SrSunSetupOwnerContact;
